import { FastlyImage } from '@components/common/image'
import Ratings from '@components/common/ratings'
import BookFreeClassButton from '@components/common/book-free-class-btn'
import StudentCountriesOverview from '@components/home/student-countries-overview'
import Partners from '@components/locale-pages/home/us/partners'
const FirstFold = (): JSX.Element => (
  <>
    <div className="relative flex justify-between px-5 md:px-3 pt-8 overflow-visible lg:rounded-b-lg">
      <div className="container mx-auto flex flex-col text-grey z-5 lg:flex-row lg:items-start gap-5">
        <div className="flex flex-col max-w-6xl">
          <h1 className="max-w-2xl text-center font-600 lg:text-left custom-home-h1">
            Codingal Reviews
          </h1>
          <p className="font-400 md:text-xl text-center md:text-left my-3 md:my-0 md:mt-5 max-w-xl">
            Explore Codingal reviews, Trustpilot ratings, and Google feedback
            all in one place.
          </p>
          <div className="flex flex-col md:flex-row md:space-x-8 space-y-5 md:space-y-0 justify-center lg:justify-start py-6 lg:pb-0">
            <StudentCountriesOverview isTextWhite={false} />
            <Ratings isDarkText />
          </div>
          <div className="flex mt-5 w-full">
            <BookFreeClassButton size="xl" variant="solid" />
          </div>
        </div>
        <div className="mx-auto">
          <FastlyImage
            src="/images/reviews-and-testimonials/first-fold-image-v2.png"
            alt="Students at Codingal"
            height={506}
            width={626}
            priority
            loading="eager"
          />
        </div>
      </div>
    </div>
    <div className="relative bg-orange-100 mt-12 lg:mt-16">
      <Partners />
    </div>
  </>
)

export default FirstFold
